module.exports = __webpack_public_path__ + "media/B21.cf84e8cb.mp3";